var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "AppDialog",
    {
      attrs: {
        title: "抽奖",
        width: "584px",
        loading: _vm.loading,
        height: "auto",
        "show-close": false,
        top: _vm.top,
        drag: _vm.drag,
        modal: false,
      },
      model: {
        value: _vm.visible,
        callback: function ($$v) {
          _vm.visible = $$v
        },
        expression: "visible",
      },
    },
    [
      _c("div", { staticClass: "lottery" }, [
        !_vm.ifCountdown
          ? _c(
              "div",
              { staticClass: "pageWrapForm" },
              [
                _c(
                  "el-form",
                  {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.loading,
                        expression: "loading",
                      },
                    ],
                    ref: "form",
                    attrs: {
                      model: _vm.form,
                      "label-width": "auto",
                      size: "small",
                      rules: _vm.rules,
                    },
                    nativeOn: {
                      submit: function ($event) {
                        $event.preventDefault()
                      },
                    },
                  },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "抽奖名称", prop: "prizeDrawId" } },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "245px" },
                            on: { change: _vm.changePrizeDraw },
                            model: {
                              value: _vm.form.prizeDrawId,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "prizeDrawId", $$v)
                              },
                              expression: "form.prizeDrawId",
                            },
                          },
                          _vm._l(_vm.prizeDrawOption, function (item) {
                            return _c("el-option", {
                              key: item.id,
                              attrs: {
                                label: item.prizeDrawName,
                                value: item.id,
                              },
                            })
                          }),
                          1
                        ),
                        _c(
                          "el-button",
                          {
                            staticClass: "m-l-20",
                            attrs: { type: "text" },
                            on: { click: _vm.onhandleAdd },
                          },
                          [_vm._v("添加抽奖")]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "参与条件",
                          prop: "participationCondition",
                        },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              {
                                1: "用户在线",
                                2: "参与任意评论",
                                3: "参与指定评论",
                              }[_vm.form.participationCondition]
                            )
                          ),
                        ]),
                        _vm.form.participationCondition === 3
                          ? _c("el-input", {
                              attrs: { disabled: "" },
                              model: {
                                value: _vm.form.assignedComment,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "assignedComment", $$v)
                                },
                                expression: "form.assignedComment",
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "开奖时间", prop: "drawPrizeType" } },
                      [
                        _c(
                          "el-radio-group",
                          {
                            on: { change: _vm.drawPrizeTypeChange },
                            model: {
                              value: _vm.form.drawPrizeType,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "drawPrizeType", $$v)
                              },
                              expression: "form.drawPrizeType",
                            },
                          },
                          [
                            _c(
                              "el-radio",
                              {
                                staticClass: "radioClass",
                                attrs: { label: 1 },
                              },
                              [
                                _c("span", [_vm._v("倒计时开奖")]),
                                _vm.form.drawPrizeType === 1
                                  ? [
                                      _c("el-input", {
                                        staticStyle: {
                                          width: "77px",
                                          "margin-left": "16px",
                                        },
                                        attrs: { clearable: "" },
                                        on: { input: _vm.delNumber },
                                        model: {
                                          value: _vm.form.countdown,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.form, "countdown", $$v)
                                          },
                                          expression: "form.countdown",
                                        },
                                      }),
                                      _vm._v(" 秒 "),
                                    ]
                                  : _vm._e(),
                              ],
                              2
                            ),
                            _c(
                              "el-radio",
                              {
                                staticClass: "radioClass",
                                attrs: { label: 2 },
                              },
                              [
                                _c("span", [_vm._v("定时开奖")]),
                                _vm.form.drawPrizeType === 2
                                  ? _c("el-date-picker", {
                                      staticStyle: {
                                        width: "180px",
                                        "margin-left": "30px",
                                      },
                                      attrs: {
                                        type: "datetime",
                                        "picker-options": _vm.pickerOptions,
                                        placeholder: "任意时间点",
                                      },
                                      model: {
                                        value: _vm.form.drawPrizeStamp,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "drawPrizeStamp",
                                            $$v
                                          )
                                        },
                                        expression: "form.drawPrizeStamp",
                                      },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { staticClass: "m-t-40" },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { size: "small", type: "primary" },
                            on: { click: _vm.onhandleStart },
                          },
                          [_vm._v("开始抽奖")]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: { size: "small" },
                            on: { click: _vm.onhandleCancel },
                          },
                          [_vm._v("取消")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          : _c("div", { staticClass: "pageWrapCountDown" }, [
              _c(
                "div",
                { staticClass: "pageWrapCountDownTime" },
                [
                  _vm.countNumber >= 0 && !_vm.loading && !_vm.ifDrawPrize
                    ? [
                        _c(
                          "div",
                          { staticClass: "pageWrapCountDownTimeTips" },
                          [_vm._v("抽奖倒计时")]
                        ),
                        _c(
                          "div",
                          { staticClass: "pageWrapCountDownTimeNumber" },
                          [
                            _vm._v(
                              _vm._s(
                                _vm._f("filterWaitingTime")(_vm.countNumber)
                              )
                            ),
                          ]
                        ),
                      ]
                    : _vm._e(),
                  _vm.loading && !_vm.ifDrawPrize
                    ? [
                        _c("div", { staticClass: "pageWrapTextTips" }, [
                          _vm._v("开奖中"),
                        ]),
                      ]
                    : _vm._e(),
                  _vm.ifDrawPrize
                    ? [
                        _c("div", { staticClass: "pageWrapTextTips" }, [
                          _vm._v("已开奖"),
                        ]),
                      ]
                    : _vm._e(),
                ],
                2
              ),
              _c("div", { staticClass: "pageWrapCountDownPeople" }, [
                _vm._v(
                  "当前参与人数" + _vm._s(_vm.drawParticipateCount) + "人"
                ),
              ]),
              _c(
                "div",
                { staticClass: "pageWrapCountDownBtn" },
                [
                  !_vm.ifDrawPrize
                    ? _c(
                        "el-button",
                        {
                          attrs: {
                            type: "primary",
                            size: "small",
                            loading: _vm.loading,
                          },
                          on: { click: _vm.drawPrizeAhead },
                        },
                        [_vm._v("提前开奖")]
                      )
                    : _vm._e(),
                  _vm.ifDrawPrize
                    ? _c(
                        "el-button",
                        {
                          attrs: {
                            type: "primary",
                            size: "small",
                            loading: _vm.loading,
                          },
                          on: { click: _vm.onhandleBack },
                        },
                        [_vm._v("返回")]
                      )
                    : _vm._e(),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small" },
                      on: { click: _vm.onhandleCancel },
                    },
                    [_vm._v("取消")]
                  ),
                ],
                1
              ),
            ]),
      ]),
      _c("div", { attrs: { slot: "footer" }, slot: "footer" }),
      _c(
        "div",
        {
          staticClass: "lotteryUserInfo",
          attrs: { slot: "title" },
          on: { click: _vm.openDialog },
          slot: "title",
        },
        [_vm.ifDrawPrize ? _c("span", [_vm._v("中奖结果")]) : _vm._e()]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }